var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListWait(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0698 2.93023C13.1628 -0.976744 6.83721 -0.976744 2.93023 2.93023C-0.976744 6.83721 -0.976744 13.1628 2.93023 17.0698C6.83721 20.9767 13.1628 20.9767 17.0698 17.0698C20.9767 13.1628 20.9767 6.7907 17.0698 2.93023ZM3.95349 16.0465C0.604651 12.6977 0.604651 7.2093 3.95349 3.86046C7.30233 0.511628 12.7907 0.511628 16.1395 3.86046C19.4884 7.2093 19.4884 12.6977 16.1395 16.0465C12.7442 19.4419 7.30233 19.4419 3.95349 16.0465Z",
    fill: "#0180C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0456 10.7884C10.4823 10.7884 10.8363 10.4344 10.8363 9.99773C10.8363 9.56104 10.4823 9.20703 10.0456 9.20703C9.60889 9.20703 9.25488 9.56104 9.25488 9.99773C9.25488 10.4344 9.60889 10.7884 10.0456 10.7884Z",
    fill: "#0180C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9325 7.90607C10.9325 8.27816 10.6069 8.60374 10.2348 8.60374C9.86269 8.60374 9.53711 8.27816 9.53711 7.90607V5.58049C9.53711 5.20839 9.86269 4.88281 10.2348 4.88281C10.6069 4.88281 10.9325 5.20839 10.9325 5.58049V7.90607Z",
    fill: "#0180C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9762 10.9359C11.2552 10.6568 11.6739 10.6568 11.9529 10.9359L15.1157 14.0987C15.3948 14.3777 15.3948 14.7963 15.1157 15.0754C14.8366 15.3545 14.418 15.3545 14.139 15.0754L10.9762 11.9126C10.7436 11.6801 10.7436 11.2149 10.9762 10.9359Z",
    fill: "#0180C7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListWait);
export default __webpack_public_path__ + "static/media/list_wait.f12d3f5b0facce68320de286a2da9972.svg";
export { ForwardRef as ReactComponent };